import {Location} from '@angular/common';
import {Component, Injector} from '@angular/core';
import {NgForm} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthService} from '../core/auth/auth.service';
import {RouteComponentBase} from '../core/route-component-base';
import {IpsTranslateService} from '@drl/core/localization/ips-translate.service';
import {TranslateService} from '@ngx-translate/core';
import {environment} from '@drl/env/environment';
import {UserSessionStoreService as StoreService} from '@drl/core/store/user-session-store.service';
import {GetIpsAssetsCommand} from '@drl/core/store/commands';
import {ApiService} from '@drl/core/api/api.service';
import {HttpHeaders, HttpParams} from '@angular/common/http';
import {AuthTokenSkipHeader} from '@drl/core/interceptors/auth.interceptor';
import {TenantConfig} from '@drl/core/store/models';
import {AnyAdapter} from '@drl/core/api/adapters/any-adapter.service';
import {ConfigurationsFacadeService} from '@drl/shared/facades';
import {NbDialogService} from '@nebular/theme';
import {ActiveSessionDialogComponent} from '@drl/shared/components/active-session-dialog/active-session-dialog.component';

@Component({
  selector: 'app-otp-verification',
  templateUrl: './otp-verification.component.html',
  styleUrls: [],
})
export class OtpVerificationComponent extends RouteComponentBase {
  logo = `/assets/logo.svg`;

  brnad = environment.brand;
  private readonly authHeaders = new HttpHeaders().set(AuthTokenSkipHeader, '');
  private dialogService: NbDialogService;
  constructor(
    protected readonly route: ActivatedRoute,
    protected readonly location: Location,
    private readonly authService: AuthService,
    private readonly apiService: ApiService,
    private readonly anyAdapter: AnyAdapter,
    protected readonly translateSvc: IpsTranslateService,
    private readonly configurationFacade: ConfigurationsFacadeService,
    private readonly store: StoreService,
    private injector: Injector, // private readonly dialogService: NbDialogService
  ) {
    super(route, location);
    // this.getAssets();
    this.translate = this.translateSvc.translate;
  }
  translate: TranslateService;

  protected router: Router;
  loading = false;
  user = {
    username: '',
    password: '',
    tenantName: '',
  };
  submitted: boolean;
  rememberMe: boolean;
  tenantsList = [];
  otp = null;
  resendTimer = 30;
  resendInterval: any;

  ngOnInit(): void {
    this.startResendTimer();
  }

  startResendTimer() {
    this.resendTimer = 30;

    this.resendInterval = setInterval(() => {
      this.resendTimer--;

      if (this.resendTimer <= 0) {
        clearInterval(this.resendInterval);
      }
    }, 1000);
  }

  resendOtp() {
    if (this.resendTimer > 0) return;
    this.otp = '';
    this.loading = true;
    this._subscriptions.push(
      this.authService.resendOtp().subscribe(
        response => {
          this.startResendTimer();
          this.loading = false;
        },
        err => {
          console.log('err==>', err);
          this.loading = false;
        },
      ),
    );
  }

  onOtpInput(event: Event) {
    const input = event.target as HTMLInputElement;

    // strip non-numeric characters
    const sanitized = input.value.replace(/[^0-9]/g, '');

    // update both DOM & ngModel
    input.value = sanitized;
    this.otp = sanitized;
  }

  otpVerification(form: NgForm): void {
    if (form.invalid) {
      return;
    }
    this.loading = true;
    this._subscriptions.push(
      this.authService.otpVerification(String(this.otp)).subscribe(
        response => {
          if (response.body) {
            this.authService.authorize(response.body);
          }
        },
        err => {
          console.log('err==>', err);
          this.loading = false;
        },
      ),
    );
  }

  ngOnDestroy() {
    if (this.resendInterval) {
      clearInterval(this.resendInterval);
    }
  }
}
